import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      borderRadius: 32,
      backgroundColor: '#f8f8f8',
      marginInline: 'auto',
      marginBlockEnd: 80,
      padding: [64, 0],
      textAlign: 'center',
      width: 'min(100%, 1012px)',

      [mediaQuery(breakpoints.tablet)]: {
        paddingInline: 16,
      },
    },
    title: {
      color: 'var(--x-accent-2-1)',
      fontSize: 60,
      fontWeight: 500,
      lineHeight: '72px',
      marginBlockEnd: 32,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 36,
        lineHeight: '48px',
      },
    },
    description: {
      color: 'var(--x-text-color-2)',
      fontSize: 20,
      fontWeight: 500,
      lineHeight: '28px',
      marginBlockEnd: 32,
    },
    btn: {
      width: 180,
      height: 48,
    },
  }),
  { name: 'MoreInfo' },
);
